import React, { useState, useEffect } from "react";
import { HeaderHLPure, PromotionalFooterPure, DialogSystemGLPure, SimpleLoading } from "../../pures";
import { Container, Grid } from '@material-ui/core'
import ProfileAdministrationPrincipalView from "./profile-administration-principal-view";
import { useTranslation } from "react-i18next"
import "./profile-administration.css";
import { ProfileValidator } from "../../../validators";
import ProfileAdministrationConfiguration from "./profile-administration-configuration";

const ProfileAdministrationView = (props) => {
    let {
        isLoadingView,
        showLoadingRequesting,
        toggleLoadingRequesting,
        showCompletedRequesting,
        toggleCompletedRequesting,
        showErrorRequesting,
        toggleErrorRequesting,
        toggleCloseErrorRequesting,
        messageError,
    } = props

    const { t } = useTranslation()
    const validator = ProfileValidator(t);

    const [headerTitle, setHeaderTitle] = useState(t("profileAdministrationView.title.header"))
    const [showPrincipalView, setShowPrincipalView] = useState(true)
    const [viewSelected, setViewSelected] = useState('')

    useEffect(() => {
        if (!viewSelected) return
        handleShowOtherView()
    }, [viewSelected])

    const handleShowOtherView = () => {
        switch (viewSelected) {
            case t("profileAdministrationPrincipalView.btn.update.address"):
                setHeaderTitle(t("profileAdministrationView.title.header"))
                break;

            default:
                setHeaderTitle(t("profileAdministrationView.title.header"))
                break;
        }
        setShowPrincipalView(false)
    }

    const handleShowPrincipalView = () => {
        setHeaderTitle(t("profileAdministrationView.title.header"))
        setShowPrincipalView(true)
        setViewSelected('')
    }

    const selectOtherView = (value) => {
        setViewSelected(value)
    }

    if (isLoadingView) return <div className="standard-wrapper">
        <SimpleLoading />
    </div>

    return (
        <div className="standard-wrapper">
            <Container>
                <Grid container spacing={2}>
                    <div className="profileAdministrationView-header">
                        <HeaderHLPure title={headerTitle} />
                    </div>
                    <div className="profileAdministrationView-body">
                        {
                            showPrincipalView ? (
                                <ProfileAdministrationPrincipalView
                                    {...props}
                                    t={t}
                                    viewSelected={viewSelected}
                                    validator={validator}
                                    selectOtherView={selectOtherView}
                                />
                            ) : (
                                <ProfileAdministrationConfiguration
                                    {...props}
                                    t={t}
                                    viewSelected={viewSelected}
                                    handleShowPrincipalView={handleShowPrincipalView}
                                    validator={validator}
                                />
                            )
                        }
                    </div>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                        <PromotionalFooterPure />
                    </Grid>
                    <DialogSystemGLPure
                        showLoadingRequesting={showLoadingRequesting}
                        toggleLoadingRequesting={toggleLoadingRequesting}

                        showCompletedRequesting={showCompletedRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}

                        showErrorRequesting={showErrorRequesting}
                        toggleErrorRequesting={toggleCloseErrorRequesting}
                        messageError={messageError}
                    />
                </Grid>
            </Container>
        </div>
    )
}

export { ProfileAdministrationView as default }